export const AUTODESK_LOAD = 'AUTODESK_LOAD'
export const autodeskLoad = () => ({
  type: AUTODESK_LOAD
})

export const AUTODESK_LOAD_SUCCESS = 'AUTODESK_LOAD_SUCCESS'
export const autodeskLoadSuccess = (
  data: AutodeskConfiguration
): AutodeskLoadSuccessAction => ({
  type: AUTODESK_LOAD_SUCCESS,
  data
})

export const AUTODESK_LOAD_FAIL = 'AUTODESK_LOAD_FAIL'
export const autodeskLoadFailure = (error: any): AutodeskLoadFailAction => ({
  type: AUTODESK_LOAD_FAIL,
  error
})

export const AUTODESK_HUB_LOAD = 'AUTODESK_HUB_LOAD'
export const autodeskHubLoad = (hubId: string) => ({
  type: AUTODESK_HUB_LOAD,
  hubId
})

export const AUTODESK_HUB_LOAD_SUCCESS = 'AUTODESK_HUB_LOAD_SUCCESS'
export const autodeskHubLoadSuccess = (
  data: AutodeskHubConfiguration
): AutodeskHubLoadSuccessAction => ({
  type: AUTODESK_HUB_LOAD_SUCCESS,
  data
})

export const AUTODESK_HUB_LOAD_FAIL = 'AUTODESK_HUB_LOAD_FAIL'
export const autodeskHubLoadFailure = (
  error: any
): AutodeskHubLoadFailAction => ({
  type: AUTODESK_HUB_LOAD_FAIL,
  error
})

// INTERFACEs
interface Region {
  value: string
  name: string
}

export interface AutodeskConfiguration {
  clientId: string
  serviceAccountEmail: string
  regions: Region[]
}

interface AutodeskLoadSuccessAction {
  type: typeof AUTODESK_LOAD_SUCCESS
  data: AutodeskConfiguration
}

interface AutodeskLoadFailAction {
  type: typeof AUTODESK_LOAD_FAIL
  error: any
}

interface Project {
  id: string
  name: string
}

export interface AutodeskHubConfiguration {
  id: string
  name: string
  projects: Project[]
}

interface AutodeskHubLoadSuccessAction {
  type: typeof AUTODESK_HUB_LOAD_SUCCESS
  data: AutodeskHubConfiguration
}

interface AutodeskHubLoadFailAction {
  type: typeof AUTODESK_HUB_LOAD_FAIL
  error: any
}
